import { useEffect, useState } from "react";
import { request } from "./api";
import type { StructureItem, StructureResponse } from "../types";

export interface GroupOption {
  id: string;
  cohortID: string;
  /** "Treatment A (treatment) · Cohort 1": enough to tell groups apart across cohorts. */
  label: string;
}

// The groups a teacher can be put in: only those marked treatment or control,
// because the server refuses the rest.
export function useStudyGroups(enabled: boolean): GroupOption[] {
  const [options, setOptions] = useState<GroupOption[]>([]);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    Promise.all([
      request<StructureResponse>("/api/admin/structure/study-groups"),
      request<StructureResponse>("/api/admin/structure/cohorts"),
    ])
      .then(([groups, cohorts]) => {
        if (cancelled) return;
        const cohortName = (id?: string) =>
          cohorts.items.find((cohort: StructureItem) => cohort.id === id)?.name ?? "";
        setOptions(
          groups.items
            .filter((group) => group.arm_kind)
            .map((group) => ({
              id: group.id,
              cohortID: group.cohort_id ?? "",
              label: `${group.name} (${group.arm_kind}) · ${cohortName(group.cohort_id)}`,
            }))
        );
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return options;
}
